export class ExcelConstants {
  static readonly MAX_ROWS = 1048576;
  static readonly MAX_COLUMNS = 16384;
}
